/* eslint-disable no-unused-vars */
import { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import * as S from './ChoosePublishers.styled';
import {
  ModalBase,
  ModalHeader,
  ModalFooter,
  ChooseBase,
  Buttons,
  ErrorComponent,
  ContentWrapp,
  Loader,
} from 'components';
import { searchExcludeAPI } from 'services/searchExcludeAPI.service';
import { useToggleState } from './useToggleState';
import Content from './Content';
import { debounce } from 'lodash-es';

const ChoosePublishers = ({ title, setSelectedPublishers, selectedPublishers }) => {
  const [search, setSearch] = useState('');
  const [isOpen, setIsOpen] = useState(false);

  const debouncedSearch = debounce((query) => {
    trigger(query);
  }, 1500);

  useEffect(() => {
    if (search.length > 3) {
      debouncedSearch(search);
    }
    return () => debouncedSearch.cancel();
  }, [search]);

  const dispatch = useDispatch();
  const [trigger, { data: foundedPublishers, isError, isFetching }] =
    searchExcludeAPI.useLazyFetchSerachPublishersQuery();

  const {
    isActive,
    toggle,
    itemsToShow,
    handleSaveSelectedPublishers,
    handleSearchOnChange,
    handleClearSearchValue,
    formIsChanged,
    isGlobal,
  } = useToggleState(
    selectedPublishers,
    foundedPublishers,
    setSearch,
    setSelectedPublishers,
    search,
    setIsOpen,
    isOpen,
  );

  const handleClose = () => {
    dispatch(searchExcludeAPI.util.resetApiState());
    setSearch('');
    setIsOpen(false);
  };

  return (
    <>
      <Buttons.SecondaryNormal
        id='categories'
        style={{ width: '100%' }}
        onClick={() => setIsOpen(true)}
      >
        Choose Publishers
      </Buttons.SecondaryNormal>
      {isOpen && (
        <ModalBase>
          <S.Box>
            <ModalHeader title={title} close={handleClose} />
            <S.Content>
              <ChooseBase.OneSection
                searchValue={search}
                searchOnChange={handleSearchOnChange}
                handleClearSearchValue={handleClearSearchValue}
                dontShowHeader
                title='Search Publishers'
              >
                <S.Loader>{isFetching && <Loader.Local delay={0.01} />}</S.Loader>
                {isError && !isFetching > 0 && search.length > 3 && <ErrorComponent />}
                {!isFetching && !isError && (
                  <ContentWrapp
                    foundedItems={itemsToShow}
                    search={search}
                    title='Use the search to choose a specific Publishers.'
                  >
                    <Content
                      foundedPublishers={itemsToShow}
                      search={search}
                      isActive={isActive}
                      toggle={toggle}
                      isGlobal={isGlobal}
                    />
                  </ContentWrapp>
                )}
              </ChooseBase.OneSection>
            </S.Content>
            <ModalFooter
              saveButtonText='Apply'
              saveButtonOnClick={handleSaveSelectedPublishers}
              close={handleClose}
              saveButtonDisabled={!formIsChanged.current}
            />
          </S.Box>
        </ModalBase>
      )}
    </>
  );
};

export default ChoosePublishers;
